import React, { useState } from "react";
import { Box, Divider, Stack, styled } from "@mui/material";
import * as SC from "SC";
import { ProfileSettings } from "components/ProfileSettings";
import { useProfileTabOpener } from "hooks/useProfileTabOpener";

const Layout = styled(Stack)`
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;

  height: 100%;

  gap: 28px;
`;

const Menu = styled(Stack)`
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
`;

const Content = styled(Stack)`
  flex: 1 1 auto;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: 10px;

  height: 100%;

  overflow-y: auto;
  overflow-x: hidden;
`;

const tabsLabels = ["Personal Settings", "Notifications"];

export const DispatcherSettings = () => {
  const [currentTab, setCurrentTab] = useState(0);

  useProfileTabOpener({ handleTabOpen: () => setCurrentTab(0) });

  return (
    <SC.OverflowedContainer>
      <Layout>
        <Menu>
          {tabsLabels.map((label, index) =>
            index === currentTab ? (
              <SC.ActiveSubmenu
                key={label}
                onClick={() => setCurrentTab(index)}
              >
                {label}
              </SC.ActiveSubmenu>
            ) : (
              <SC.Submenu key={label} onClick={() => setCurrentTab(index)}>
                {label}
              </SC.Submenu>
            )
          )}
        </Menu>
        <Divider orientation="vertical" />
        <Content>
          {currentTab === 0 && <ProfileSettings />}
          {currentTab === 1 && <Box>{tabsLabels[1]}</Box>}
        </Content>
      </Layout>
    </SC.OverflowedContainer>
  );
};
